import React from 'react';
import PropTypes from 'prop-types';
import { InformationFlow } from 'ThreeTerminal_mobile';
import errorBoundary from '@ifeng/errorBoundary';
import { callApp } from '@ifeng/callapp';
import styles from './index.css';

class Knowledge extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        more: true,
    };

    // 判断是否是客户端
    isClient = () => {
        return window && typeof window.grounds !== 'undefined';
    };

    handleMoreData = async () => {
        if (this.isClient()) {
            const { content } = this.props;

            this.setState({
                more: false,
            });

            return {
                content: content.slice(3),
                isEnd: false,
            };
        } else {
            callApp({
                client: 'newsApp',
                docType: 'web',
                pid: 'https://ishare.ifeng.com/c/s/80kdzDaUKoa',
                kind: 'inter_dsjzt01',
                noKindFrom: 1,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191364941',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8819',
            });
        }
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.knowledge}>
                <div className={styles.knowledgeMd}>
                    <img
                        className={styles.knowledgeMdImg}
                        src="https://x0.ifengimg.com/ucms/2020_43/0B3C9B69CE6272652A34BA6F712D7EEEF77F1629_w254_h110.png"
                    />
                </div>
                <div className={styles.knowledgeBd}>
                    <InformationFlow
                        content={content.slice(0, 3)}
                        isLazyImage={true}
                        isSpreadMoreIcon={true}
                        handleLoadingDataFunc={this.handleMoreData}
                        isDisplayLoadingMore={this.state.more}
                        getExposureData={this.getExposureData}
                        moreText={'查看更多'}
                    />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Knowledge);
